var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Reset, colour=Primary, htmlTag=img, assetKey=Content, state=Selected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "restart_alt",
    d: "M11.8295 21.225C9.81286 20.975 8.14203 20.0959 6.81703 18.5875C5.49203 17.0792 4.82953 15.3084 4.82953 13.275C4.82953 12.175 5.0462 11.1209 5.47953 10.1125C5.91286 9.10419 6.52953 8.22502 7.32953 7.47502L8.75453 8.90002C8.1212 9.46669 7.64203 10.125 7.31703 10.875C6.99203 11.625 6.82953 12.425 6.82953 13.275C6.82953 14.7417 7.2962 16.0375 8.22953 17.1625C9.16286 18.2875 10.3629 18.975 11.8295 19.225V21.225ZM13.8295 21.225V19.225C15.2795 18.9584 16.4754 18.2667 17.417 17.15C18.3587 16.0334 18.8295 14.7417 18.8295 13.275C18.8295 11.6084 18.2462 10.1917 17.0795 9.02502C15.9129 7.85836 14.4962 7.27502 12.8295 7.27502H12.7545L13.8545 8.37502L12.4545 9.77502L8.95453 6.27502L12.4545 2.77502L13.8545 4.17502L12.7545 5.27502H12.8295C15.0629 5.27502 16.9545 6.05002 18.5045 7.60002C20.0545 9.15002 20.8295 11.0417 20.8295 13.275C20.8295 15.2917 20.167 17.0542 18.842 18.5625C17.517 20.0709 15.8462 20.9584 13.8295 21.225Z",
    fill: "#0595FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.e44a8772dbc8275ab5033409064db153.svg";
export { ForwardRef as ReactComponent };